export const questionSupplementWidth: string = '30vw';